import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBilling = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V11.2C3 12.8802 3 13.7202 3.32698 14.362C3.6146 14.9265 4.07354 15.3854 4.63803 15.673C5.27976 16 6.11984 16 7.8 16H12.2C13.8802 16 14.7202 16 15.362 15.673C15.9265 15.3854 16.3854 14.9265 16.673 14.362C17 13.7202 17 12.8802 17 11.2V8.8C17 7.11984 17 6.27976 16.673 5.63803C16.3854 5.07354 15.9265 4.6146 15.362 4.32698C14.7202 4 13.8802 4 12.2 4Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8H16",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12H10",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBilling;
